import {Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {
    MooringPlaceBoatDto,
    MooringPlaceService
} from '../../../_services/configuration-services';
import {GesConstants} from '../../../app.constants';

@Component({
    selector: 'app-customer-boats-summary',
    templateUrl: './customer-boats-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerBoatsSummaryComponent implements OnChanges {

    @Input() serviceId: string = null!;
    @Input() customerId: string = null!;

    customerBoats: MooringPlaceBoatDto[] = [];

    Csts = GesConstants;

    constructor(private readonly mooringPlaceService: MooringPlaceService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['customerId']?.currentValue) {
            this.mooringPlaceService.getMooringPlaceBoatsForCustomer(this.serviceId, this.customerId).subscribe(customerBoats => this.customerBoats = customerBoats);
        }
    }
}
